import type { FilterOption } from 'src/data/browse/filters'

interface ActiveFilterProps<FilterArrayItem> {
  options: FilterOption<FilterArrayItem>[]
  onChange: (value: FilterArrayItem[] | null) => void
  value: FilterArrayItem[] | null
}

export default function ActiveFilters<FilterArrayItem>({
  options,
  onChange,
  value
}: ActiveFilterProps<FilterArrayItem>) {
  if (!value || value.length === 0) {
    return null
  }

  const activeFilters = options.filter((o) => value.includes(o.value))

  const handleClearFilter = (filter: FilterArrayItem) => {
    const result = value?.filter((v) => v !== filter) || null
    const update = Array.isArray(result) && result.length > 0 ? result : null
    onChange(update)
  }

  return (
    <>
      {activeFilters.map((activeFilter) => (
        <span
          key={activeFilter.value as unknown as string}
          className="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium bg-white text-gray-900"
        >
          <span>{activeFilter.label}</span>
          <button
            type="button"
            className="flex-shrink-0 ml-1 h-4 w-4 p-1 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500 outline-brand-500"
            onClick={() => handleClearFilter(activeFilter.value)}
          >
            <span className="sr-only">Remove filter for {activeFilter.label}</span>
            <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
              <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
            </svg>
          </button>
        </span>
      ))}
    </>
  )
}
